export const isProduction = (): boolean => import.meta.env.VITE_ENV === 'production';

const DEV_OVERRIDE_PARAM = 'zyrafy-wchodza-na-szafy';
const DEV_OVERRIDE_KEY = 'fh_dev_override';

export const hasDevOverride = (): boolean => {
  if (typeof sessionStorage === 'undefined') return false;
  if (new URLSearchParams(window.location.search).has(DEV_OVERRIDE_PARAM)) {
    sessionStorage.setItem(DEV_OVERRIDE_KEY, '1');
    return true;
  }
  return sessionStorage.getItem(DEV_OVERRIDE_KEY) === '1';
};

const ACCESS_TOKEN_KEY = 'fh_access_token';

// A temporary-access invite link (?access=<token>) unlocks the pre-public
// ComingSoon wall and KEEPS it unlocked on this browser (localStorage, unlike
// the session-scoped dev override). This is UX only — the real gate is the
// flat.access_gate backend hook, so a bad token still can't produce a session.
export const hasAccessInvite = (): boolean => {
  if (typeof localStorage === 'undefined') return false;
  const token = new URLSearchParams(window.location.search).get('access');
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    return true;
  }
  return localStorage.getItem(ACCESS_TOKEN_KEY) != null;
};

export const isProductionGated = (): boolean =>
  isProduction() && !hasDevOverride() && !hasAccessInvite();

const HOSTY_LOKALNE = new Set(['localhost', '127.0.0.1']);
const PREFIKSY_DEWELOPEROW = ['maciej.', 'piotr.', 'bartek.'];

/**
 * Dev panels (the profile's „Dev · completion”, Settings' „Dev · test alert e-mail”) show only on
 * the developers' sites — local dev and maciej./piotr./bartek.flathero.pl — and never on
 * stage.flathero.pl or production (Maciek 20.10, PreLaunchChecklist 2.1). Decided by hostname
 * because VITE_ENV is set only for the prod build, so stage and the dev envs share one bundle.
 *
 * UX ONLY (Convention 29): this hides a panel, it protects nothing. Anyone can open the bundle
 * and call what a panel calls, so every action a dev panel takes must be gated server-side
 * (e.g. send-filter-alerts' test mode requires flat.is_admin()).
 */
export const pokazujPaneleDev = (hostname: string = window.location.hostname): boolean => {
  if (isProduction()) return false;
  const h = hostname.toLowerCase();
  return HOSTY_LOKALNE.has(h) || PREFIKSY_DEWELOPEROW.some((p) => h.startsWith(p));
};
